import dayjs from "dayjs";

export const isValidTimeRange = (fromTime, toTime) => {
  if (!fromTime || !toTime) return false;

  const diffInMinutes = dayjs(toTime).diff(dayjs(fromTime), "minute");
  return diffInMinutes >= 60;
};
